import Vue from 'vue'
import VueI18n from 'vue-i18n'
import LangEn from '@/lang/en'

Vue.use(VueI18n)

const messages = {
  fallbackEn: LangEn,
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'fallbackEn',
  messages: messages,
  silentTranslationWarn: process.env.VUE_APP_I18N_SILENT_WARNINGS === 'true'
})
